import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);
// 路由管理
const routes = [
  { path: '/', component: () => import('@/pages/Home'), meta: { index: 0 } },
  { path: '/overview', component: () => import('@/pages/Overview'), meta: { index: 2 } },
  { path: '/assess', component: () => import('@/pages/Assess'), meta: { index: 2 } },
  { path: '/scheme', component: () => import('@/pages/Scheme'), meta: { index: 2 } },
  { path: '/details', component: () => import('@/pages/Details'), meta: { index: 3 } },
  { path: '/recuperate', component: () => import('@/pages/Recuperate'), meta: { index: 3 } },
  { path: '/nutritions', component: () => import('@/pages/Nutritions'), meta: { index: 2 } },
  { path: '/nutrition', component: () => import('@/pages/Nutrition'), meta: { index: 3 } },
  { path: '/tissue', component: () => import('@/pages/Tissue'), meta: { index: 3 } },
  { path: '/compare', component: () => import('@/pages/Compare'), meta: { index: 3 } },
  { path: '/condition', component: () => import('@/pages/Condition'), meta: { index: 3 } },
  { path: '/questionnaire', component: () => import('@/pages/AIQuestionnaire'), meta: { index: 2 } },
  { path: '/microelement', component: () => import('@/pages/Microelement'), meta: { index: 2 } },
];

// const scrollPositions = {}; // 存储每个页面的滚动位置

const router = new VueRouter({
  mode: 'history',
  routes,
  // 必须组件不被缓存的情况下有效
  scrollBehavior(to, from, savedPosition) {
    // 如果存在savedPosition（通过浏览器的前进/后退按钮触发的导航），则返回savedPosition
    if (savedPosition) {
      return savedPosition;
    }
    // 如果目标路由有hash，则滚动到hash对应的元素
    if (to.hash) {
      return { selector: to.hash };
    }
    // 否则保持当前滚动位置
    return { x: 0, y: 0, behavior: 'smooth' };
  }
});

// 保存离开页面前的滚动位置
// router.beforeEach((to, from, next) => {
//   scrollPositions[from.fullPath] = window.scrollY || window.pageYOffset;
//   console.log('scrollPositions',scrollPositions)
//   next();
// });

// 进入页面后恢复滚动位置
// router.afterEach((to) => {
//   Vue.nextTick(() => {
//   console.log('scrollPositions2',scrollPositions)
//   console.log('to.fullPath',to.fullPath)

//     const y = scrollPositions[to.fullPath] || 0;
//   console.log('y',y)

//     window.scrollTo(0, y);
//   });
// });

export default router;
